import script from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=a74e008a&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a74e008a"]])

export default __exports__